module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/3-c903c94418dc5f2ccde84333f84ec1cd.png";